import classnames from 'classnames';

import { IconButton, Collapse as MuiCollapse } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import Typography from '@classify/react-core-components/Typography';
import collapsible from '../../hoc/collapsible';

/* istanbul ignore next */
const styles = ({ typography, transitions, palette }) => ({
  root: {
    ...typography.body1,
  },

  expand: {
    transform: 'rotate(0deg)',
    transition: transitions.create('transform', {
      duration: transitions.duration.shortest,
    }),
  },

  expandOpened: {
    transform: 'rotate(180deg)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    marginLeft: 'auto',
  },
  icon: {
    color: palette.text.onMain,
  },
});

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
export const Collapse = ({
  onToggleCollapse = () => {},
  isCollapsed = false,
  shouldHideCollapseIcon = false,
  classes = {},
  title = null,
  children = null,
  className = null,
  ariaLabel = 'Show less information',
}) => (
  <div className={classnames(className, classes.root)} aria-expanded={!isCollapsed}>
    {!shouldHideCollapseIcon && (
      <div
        className={classes.header}
        onClick={/* istanbul ignore next */ () => onToggleCollapse(isCollapsed)}
      >
        <Typography component="div" variant="h3" className="oc-collapse__title">
          {title}
        </Typography>
        <div
          className={classnames(
            classes.expand,
            {
              [classes.expandOpened]: isCollapsed,
            },
            classes.button
          )}
        >
          <IconButton size="large" aria-label={ariaLabel}>
            <ExpandLessIcon className={classes.icon} />
          </IconButton>
        </div>
      </div>
    )}

    {children && <MuiCollapse in={!isCollapsed}>{children}</MuiCollapse>}
  </div>
);

const StyledCollapse = withStyles(styles)(Collapse);

export default collapsible(StyledCollapse);
